import React from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import StationsList from '../Data/sampleprojectdata.json';

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup
} from "react-simple-maps";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

// import allStates from "../Data/allstates.json";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";


const StationsChart = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [projectId, setProjectId] = React.useState(0);
  const [projectName, setProjectName] = React.useState('0');
  
  const getProject = (id, name) => {    
    setProjectId(id);
    localStorage.setItem('projectName', name);
    setProjectName(name);
    setOpen(true);
  };


  return (
    <>
      <ComposableMap projection="geoAlbers">
        <ZoomableGroup zoom={1}>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="#DDD"
                  stroke="#FFF"
                />
              ))
            }
          </Geographies>

          {/* <Marker coordinates={[-74.006, 40.7128]}>
        <circle r={8} fill="#F53" onClick={() => getProject(1)} />
      </Marker> */}
          {StationsList.map(({ id, name, coordinates, markerOffset }) => (
            <Marker key={name} coordinates={coordinates} onClick={() => getProject(id, name)} >
              <g
                fill="none"
                stroke="#FF5533"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(-12, -24)"
              >
                <circle cx="12" cy="10" r="3" />
                <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
              </g>
              <text
                textAnchor="middle"
                y={markerOffset}
                style={{ fontFamily: "system-ui", fill: "#5D5A6D", height: "12" }}
              >
                {name}
              </text>
            </Marker>
          ))}
        </ZoomableGroup>
      </ComposableMap>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h2" component="h2">
            {projectName}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Would you like to open this project?
          </Typography>
          <Button variant="contained" onClick={() =>  window.location.href = `/dashboard/operations`}>Load Project</Button>
        </Box>
      </Modal>
    </>
  );
};

export default StationsChart;
